module.exports = __webpack_public_path__ + "media/images/riders/ANNIE_LAST-2dc6bf0a62409487b3e4dd608dc970f8.png";